import { render } from "./InputFileReader.vue?vue&type=template&id=507663e0&scoped=true&lang=true"
import script from "./InputFileReader.vue?vue&type=script&lang=js"
export * from "./InputFileReader.vue?vue&type=script&lang=js"

import "./InputFileReader.vue?vue&type=style&index=0&id=507663e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-507663e0"

export default script